import React, { ReactElement, memo, useMemo } from "react";

//types
import { DeliveryAddress } from "@swiggy-private/payment-types";

//helpers
import { isEmpty } from "@swiggy-private/js-utils";
import { getAddressAnnotation, getAddressInfoFromDeliveryAddress } from "@swiggy-private/core-ui";

//styles
import { Address, Annotation } from "./styles";
import { hasInvalidAddressCategory } from "@payment-ui/components/tick-screen/helpers";

interface DeliveryAddressProps {
    deliveryAddress?: DeliveryAddress;
    maxLines?: number;
}

function TransitionDeliveryAddress({ deliveryAddress, maxLines = 2 }: DeliveryAddressProps): ReactElement | null {
    const category = useMemo(() => {
        return hasInvalidAddressCategory(deliveryAddress)
            ? deliveryAddress?.addressCategory
            : deliveryAddress?.userIntentAddressCategory;
    }, [deliveryAddress]);

    const annotation = useMemo(() => {
        if (hasInvalidAddressCategory(deliveryAddress)) {
            return getAddressAnnotation(deliveryAddress, category);
        }
        return deliveryAddress?.annotation || getAddressAnnotation(deliveryAddress, category);
    }, [deliveryAddress, category]);

    const addressInfo = useMemo(() => getAddressInfoFromDeliveryAddress(deliveryAddress), [deliveryAddress]);

    if (isEmpty(deliveryAddress)) return null;
    return (
        <>
            <Annotation
                variant="V2.heading1.neutral.black"
                maxLines={1}
                color="text_Highest_Emphasis"
                textAlign="center"
            >
                {annotation}
            </Annotation>
            <Address
                variant="V2.subheading1.neutral.medium"
                color="text_High_Emphasis"
                maxLines={maxLines}
                textAlign="center"
            >
                {addressInfo}
            </Address>
        </>
    );
}

export default memo(TransitionDeliveryAddress);
